import {
  LayoutDashboard, Wallet, ArrowLeftRight, Users, Package, BadgeDollarSign,
  Banknote, FileBarChart, Shield, History, UserCheck,
} from "lucide-react";

export const NAV = [
  { key: "dashboard", to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { key: "caixa", to: "/caixa", label: "Caixa", icon: Wallet },
  { key: "movimentacoes", to: "/movimentacoes", label: "Movimentações", icon: ArrowLeftRight },
  { key: "alunos", to: "/alunos", label: "Alunos", icon: Users },
  { key: "produtos", to: "/produtos", label: "Produtos", icon: Package },
  { key: "planos", to: "/planos", label: "Planos", icon: BadgeDollarSign },
  { key: "pagamentos", to: "/pagamentos", label: "Pagamentos", icon: Banknote },
  { key: "relatorios", to: "/relatorios", label: "Relatórios", icon: FileBarChart },
  { key: "vendedores", to: "/vendedores", label: "Vendedores", icon: UserCheck, adminOnly: true },
  { key: "usuarios", to: "/usuarios", label: "Usuários", icon: Shield, adminOnly: true },
  { key: "auditoria", to: "/auditoria", label: "Auditoria", icon: History, adminOnly: true },
];

export const CONFIGURABLE_PAGES = NAV.filter((n) => !n.adminOnly);
